/*
 * Model class Form
 */
export default class Form {
	constructor() {
		this.form_inputs = {
			label 		: '<label>[[value]]</label>',
			text 		: '<input type="text" class="form-control" name="[[name]]" data-toggle="popover" data-placement="bottom" value="[[value]]" [[required]]>',
			password	: '<input type="password" class="form-control" name="[[name]]" data-toggle="popover" data-placement="bottom" value="[[value]]" [[required]]>',
			hidden 		: '<input type="hidden" class="form-control" name="[[name]]" data-toggle="popover" data-placement="bottom" value="[[value]]" />',
			radio 		: '<a class="btn btn-primary btn-sm [[active]]" data-toggle="[[toggle_name]]" data-title="[[data_title]]">[[display_name]]</a>',
			checkbox 	: '',
			dropdown 	: ''
		};
	}

	combine_input(type, name, value, colnum, required) {
		var cInput 	= this.input(type, name, value, required),
			cDivCol	= this.div_col(cInput, colnum);

		return cDivCol;
	}

	input(type, name, value, required) {
		var html = this.form_inputs[type];

		html = html.replace('[[name]]', name);
		html = html.replace('[[value]]', value);

		if (required) {
			html = html.replace('[[required]]', 'required');
		} else {
			html = html.replace('[[required]]', '');
		}

		return html;
	}

	div_col(html, colnum) {
		return `<div class="col-md-${colnum}">${html}</div>`;
	}

	form_group(insert) {
		return `<div class="row form-group">
					${insert}
				</div>`;
	}
	
	validate(field, value) {
		console.log(value);
		
		if (value == "") {
			return field.error.empty;
		}
		
		switch (field.name) {
			case 'email':
				var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				
				if (!pattern.test(value)) {
					return field.error.valid;
				}
			break;
		}
		
		return true;
	}
}
